import { render, staticRenderFns } from "./vc-radio.vue?vue&type=template&id=4ee69a9b&scoped=true&"
import script from "./vc-radio.vue?vue&type=script&lang=js&"
export * from "./vc-radio.vue?vue&type=script&lang=js&"
import style0 from "./vc-radio.vue?vue&type=style&index=0&id=4ee69a9b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee69a9b",
  null
  
)

export default component.exports